import { createModalContext } from '#/features/modal';

export const [WalletModalProvider, useWalletModalView, useWalletModalActions] =
  createModalContext('Wallet');
